import type { NestedFilter } from '@@partner:types:graphql'
import type { FilterConfig } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { prepareProductGroupsFilter } from '@@partner:helpers/productGroup'

export interface ProductGroupsFiltersType {
  ids: string[]
  name: string
  label: string
  type: string
}

const defaultFilter: ProductGroupsFiltersType = {
  ids: [],
  name: '',
  label: '',
  type: ''
}

const filterConfig: FilterConfig[] = [
  createFilter.text('name', 'Название'),
  createFilter.text('label', 'Лейбл'),
  createFilter.text('type', 'Тип'),
  createFilter.multiline('ids', 'ID групп (по строкам)', { expandable: true, rows: 3 })
]

export interface ProductGroupsFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

export default function ProductGroupsFilter ({
  onFilterChanged
}: ProductGroupsFilterProps) {
  const handleSearch = useCallback((state: ProductGroupsFiltersType) => {
    onFilterChanged(prepareProductGroupsFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<ProductGroupsFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}